<script setup lang="ts">
import type { Toast } from '~kui/types/toast';

import KUICoreToast from '~kui/components/KUI/Core/Toast/KUICoreToast.vue';
import { ToastProvider, ToastViewport } from 'reka-ui';

interface Props {
  toasts: readonly Toast[];
}

defineProps<Props>();

const emit = defineEmits<{
  close: [id: string];
}>();
</script>

<template>
  <ToastProvider>
    <KUICoreToast
      v-for="toast in toasts"
      :key="toast.id"
      :variant="toast.variant"
      :message="toast.message"
      :title="toast.title"
      :duration="toast.duration"
      @close="emit('close', toast.id)"
    />

    <ToastViewport class="pointer-events-none fixed top-0 right-0 z-100 flex max-h-screen w-full flex-col-reverse gap-2 p-4 sm:max-w-sm sm:flex-col" />
  </ToastProvider>
</template>
